<script>
  // import PayWithCard from '@/components/cashier/PayWithCard.vue';
  import PayWithCrypto from '@/components/cashier/PayWithCrypto.vue';

  export default {
    name: 'PurchaseTab',

    emits: ['payment-method-change'],

    components: {
      // PayWithCard,
      PayWithCrypto,
    },

    data: () => ({
      activeTab: '',
      activeComponent: '',
    }),

    computed: {
      tabs: () => [
        // {
        //   value: 'card',
        //   text: 'Pay with Card',
        //   component: 'PayWithCard',
        // },
        {
          value: 'crypto',
          text: 'Pay with Crypto',
          component: 'PayWithCrypto',
        },
      ],
    },

    mounted() {
      this.activeTab = this.tabs[0].value;
      this.activeComponent = this.tabs[0].component;
      this.$emit('payment-method-change', this.activeTab);
    },

    methods: {
      onTabClick(tab) {
        this.activeTab = tab.value;
        this.activeComponent = this.tabs.find((tab) => tab.value === this.activeTab)?.component;
        this.$emit('payment-method-change', this.activeTab);
      },
    },
  };
</script>

<template>
  <div class="purchase-tab">
    <!--    <div class="tab-buttons">-->
    <!--      <div-->
    <!--        v-for="tab in tabs"-->
    <!--        :key="tab.value"-->
    <!--        class="tab-button"-->
    <!--        :class="{ 'tab-button&#45;&#45;active': tab.value === activeTab }"-->
    <!--        :aria-label="tab.text"-->
    <!--        @click="onTabClick(tab)"-->
    <!--      >-->
    <!--        <span>-->
    <!--          {{ tab.text }}-->
    <!--        </span>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="tab-content">
      <component :is="activeComponent" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .tab-buttons {
    display: flex;
    padding: 2px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex: 1 0 0;
    border-radius: 6px;
    background: #fff;
  }

  .tab-button {
    display: flex;
    padding: 11px 10px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex: 1 0 0;
    cursor: pointer;
    border-radius: 6px;

    span {
      color: #1c0630;
      text-align: center;
      font-size: 13px;
      font-style: normal;
      font-weight: 600;
      line-height: 120%;
    }

    &--active {
      cursor: default;
      background: #350f53;

      span {
        color: #fff;
      }
    }

    &:not(.tab-button--active):hover {
      box-shadow: 0 0 2px 0 inset rgba(#350f53, 0.5);
    }
  }

  .tab-content {
    margin-top: 16px;
  }
</style>
